/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import dayjs from "dayjs"
import { quotOrZero, decimalPlus } from "../../../ts/util/decimalUtil"
import {
  T売上予算,
  UriageYosanListGetReq,
  UriageYosanListGetRes,
  UriageYosanListPutReq,
  月額プロパティ名,
} from "../../../service/budget/uriageYosan/TUriageYosan"
import uriageYosanService from "../../../service/budget/uriageYosan/uriageYosanService"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import { RootState } from "../../../globalStore/rootreducer"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import { 予算_実績メニューコード } from "../../../constant/menuCode"
import util from "../../../ts/util"
import {
  T年ComboBoxItem,
  YearComboBox,
} from "../../../components/ComboBox/YearComboBox"
import { e項目 } from "./UriageYosanConstant"

const 列集計データ生成 = (
  dataItem: T売上予算
): {
  年間金額: number
  上期金額: number
  下期金額: number
} => {
  const 上期金額 = decimalPlus([
    dataItem.金額４月,
    dataItem.金額５月,
    dataItem.金額６月,
    dataItem.金額７月,
    dataItem.金額８月,
    dataItem.金額９月,
  ])
  const 下期金額 = decimalPlus([
    dataItem.金額１０月,
    dataItem.金額１１月,
    dataItem.金額１２月,
    dataItem.金額１月,
    dataItem.金額２月,
    dataItem.金額３月,
  ])
  return {
    年間金額: decimalPlus([上期金額, 下期金額]),
    上期金額,
    下期金額,
  }
}

/**
 *　売上予算（部所年間）
 * @returns
 */
const UriageYosanNenkanRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const 当営業日 = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "UriageYosanNenkanRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: UriageYosanListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: UriageYosanListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new uriageYosanService().getUriageYosanList(
        currentSearchCondition
      )
      const resData: T売上予算[] = []
      // 月ごとのフィールドを作成して格納する
      res.data.forEach((d: UriageYosanListGetRes) => {
        let 月 = d.年月.slice(-2)
        let rowData: T売上予算 = {
          売上予算List: [],
          年月: "",
          部所コード: "",
          部所名: "",
          項目: "",
          金額１月: 0,
          金額２月: 0,
          金額３月: 0,
          金額４月: 0,
          金額５月: 0,
          金額６月: 0,
          金額７月: 0,
          金額８月: 0,
          金額９月: 0,
          金額１０月: 0,
          金額１１月: 0,
          金額１２月: 0,
          年間金額: 0,
          上期金額: 0,
          下期金額: 0,
        }
        rowData.売上予算List!.push({
          部所コード: d.部所コード,
          売上予算ID: d.売上予算ID,
          年月: d.年月,
          予算額: d.金額,
          更新日時: d.更新日時,
        })
        rowData.部所名 = d.部所名
        rowData.部所コード = d.部所コード
        rowData.項目 = d.項目
        rowData.報告テキスト１ = d.報告テキスト１
        rowData.報告テキスト２ = d.報告テキスト２
        rowData.報告テキスト３ = d.報告テキスト３
        rowData.報告テキスト４ = d.報告テキスト４
        rowData.報告テキスト５ = d.報告テキスト５
        switch (月) {
          case "04":
            rowData.金額４月 = d.金額
            break
          case "05":
            rowData.金額５月 = d.金額
            break
          case "06":
            rowData.金額６月 = d.金額
            break
          case "07":
            rowData.金額７月 = d.金額
            break
          case "08":
            rowData.金額８月 = d.金額
            break
          case "09":
            rowData.金額９月 = d.金額
            break
          case "10":
            rowData.金額１０月 = d.金額
            break
          case "11":
            rowData.金額１１月 = d.金額
            break
          case "12":
            rowData.金額１２月 = d.金額
            break
          case "01":
            rowData.金額１月 = d.金額
            break
          case "02":
            rowData.金額２月 = d.金額
            break
          case "03":
            rowData.金額３月 = d.金額
            break
          default:
            break
        }
        resData.push(rowData)
      })
      // 部所・項目でGROUP BY的な処理
      const d = resData.reduce((result: T売上予算[], current) => {
        const element = result.find(
          (r) => r.部所名 === current.部所名 && r.項目 === current.項目
        )
        if (element) {
          let 上期金額 = decimalPlus([
            element.上期金額 ?? 0,
            current.金額４月,
            current.金額５月,
            current.金額６月,
            current.金額７月,
            current.金額８月,
            current.金額９月,
          ])
          let 下期金額 = decimalPlus([
            element.下期金額 ?? 0,
            current.金額１０月,
            current.金額１１月,
            current.金額１２月,
            current.金額１月,
            current.金額２月,
            current.金額３月,
          ])
          if (current.売上予算List) {
            element.売上予算List?.push(current.売上予算List[0])
          }
          element.上期金額 = 上期金額
          element.下期金額 = 下期金額
          element.年間金額 = decimalPlus([上期金額, 下期金額])
          element.金額４月 = decimalPlus([element.金額４月, current.金額４月])
          element.金額５月 = decimalPlus([element.金額５月, current.金額５月])
          element.金額６月 = decimalPlus([element.金額６月, current.金額６月])
          element.金額７月 = decimalPlus([element.金額７月, current.金額７月])
          element.金額８月 = decimalPlus([element.金額８月, current.金額８月])
          element.金額９月 = decimalPlus([element.金額９月, current.金額９月])
          element.金額１０月 = decimalPlus([
            element.金額１０月,
            current.金額１０月,
          ])
          element.金額１１月 = decimalPlus([
            element.金額１１月,
            current.金額１１月,
          ])
          element.金額１２月 = decimalPlus([
            element.金額１２月,
            current.金額１２月,
          ])
          element.金額１月 = decimalPlus([element.金額１月, current.金額１月])
          element.金額２月 = decimalPlus([element.金額２月, current.金額２月])
          element.金額３月 = decimalPlus([element.金額３月, current.金額３月])
        } else {
          current.上期金額 = decimalPlus([
            current.金額４月,
            current.金額５月,
            current.金額６月,
            current.金額７月,
            current.金額８月,
            current.金額９月,
          ])
          current.下期金額 = decimalPlus([
            current.金額１０月,
            current.金額１１月,
            current.金額１２月,
            current.金額１月,
            current.金額２月,
            current.金額３月,
          ])
          current.年間金額 = decimalPlus([current.上期金額, current.下期金額])

          result.push(current)
        }
        return result
      }, [])

      // 前年実績比を作成
      const gridRowData = d.reduce((result: T売上予算[], current) => {
        const yosan = result.find(
          (r) => r.部所名 === current.部所名 && r.項目 === e項目.予算
        )
        if (
          yosan &&
          yosan.部所名 === current.部所名 &&
          current.項目 === e項目.前年実績
        ) {
          result.push(current)
          const tassei: T売上予算 = {
            年月: yosan.年月,
            部所名: yosan.部所名,
            部所コード: yosan.部所コード,
            項目: e項目.前年実績比,
            年間金額: quotOrZero(yosan.年間金額 ?? 0, current.年間金額 ?? 0),
            上期金額: quotOrZero(yosan.上期金額 ?? 0, current.上期金額 ?? 0),
            下期金額: quotOrZero(yosan.下期金額 ?? 0, current.下期金額 ?? 0),
            金額４月: quotOrZero(yosan.金額４月, current.金額４月),
            金額５月: quotOrZero(yosan.金額５月, current.金額５月),
            金額６月: quotOrZero(yosan.金額６月, current.金額６月),
            金額７月: quotOrZero(yosan.金額７月, current.金額７月),
            金額８月: quotOrZero(yosan.金額８月, current.金額８月),
            金額９月: quotOrZero(yosan.金額９月, current.金額９月),
            金額１０月: quotOrZero(yosan.金額１０月, current.金額１０月),
            金額１１月: quotOrZero(yosan.金額１１月, current.金額１１月),
            金額１２月: quotOrZero(yosan.金額１２月, current.金額１２月),
            金額１月: quotOrZero(yosan.金額１月, current.金額１月),
            金額２月: quotOrZero(yosan.金額２月, current.金額２月),
            金額３月: quotOrZero(yosan.金額３月, current.金額３月),
            報告テキスト１: yosan.報告テキスト１,
            報告テキスト２: yosan.報告テキスト２,
            報告テキスト３: yosan.報告テキスト３,
            報告テキスト４: yosan.報告テキスト４,
            報告テキスト５: yosan.報告テキスト５,
          }
          result.push(tassei)
        } else {
          result.push(current)
        }
        return result
      }, [])
      gridRowData.forEach((d) => {
        d.年間金額str = cnvUriageStr(d.年間金額 ?? 0, d.項目)
        d.上期金額str = cnvUriageStr(d.上期金額 ?? 0, d.項目)
        d.下期金額str = cnvUriageStr(d.下期金額 ?? 0, d.項目)
        d.金額４月str = cnvUriageStr(d.金額４月, d.項目)
        d.金額５月str = cnvUriageStr(d.金額５月, d.項目)
        d.金額６月str = cnvUriageStr(d.金額６月, d.項目)
        d.金額７月str = cnvUriageStr(d.金額７月, d.項目)
        d.金額８月str = cnvUriageStr(d.金額８月, d.項目)
        d.金額９月str = cnvUriageStr(d.金額９月, d.項目)
        d.金額１０月str = cnvUriageStr(d.金額１０月, d.項目)
        d.金額１１月str = cnvUriageStr(d.金額１１月, d.項目)
        d.金額１２月str = cnvUriageStr(d.金額１２月, d.項目)
        d.金額１月str = cnvUriageStr(d.金額１月, d.項目)
        d.金額２月str = cnvUriageStr(d.金額２月, d.項目)
        d.金額３月str = cnvUriageStr(d.金額３月, d.項目)
      })
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(gridRowData, pageSize) })
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query = queryString.parse(
      location.search
    ) as unknown as UriageYosanListGetReq
    if (query.年度 != null) {
      set年度(query.年度)
    }
    set部所コード(query.部所コード ?? null)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): UriageYosanListGetReq => {
    return {
      年度: 年度 ?? 0,
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: UriageYosanListGetReq
  ) => {
    const 部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      年度:
        searchCondition.年度 != null
          ? `${searchCondition.年度}年度`
          : undefined,
      部所: 部所 && `${部所?.部所コード}:${部所?.部所略称}`,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年度(dayjs(当営業日).year())
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.pastingCell.addHandler(beginningEdit)
    grid.cellEditEnding.addHandler(cellEditEnding)
    grid.cellEditEnded.addHandler(cellEditEnded)

    const columnHeaderColumns = grid.columnHeaders.columns

    columnHeaderColumns.forEach((column) => {
      if (
        [
          "年間金額str",
          "上期金額str",
          "下期金額str",
          "金額４月str",
          "金額５月str",
          "金額６月str",
          "金額７月str",
          "金額８月str",
          "金額９月str",
          "金額１０月str",
          "金額１１月str",
          "金額１２月str",
          "金額１月str",
          "金額２月str",
          "金額３月str",
        ].some((binding) => binding === column.binding)
      ) {
        column.align = "center"
      }
    })
    grid.refresh()
  }
  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    let col = s.columns[e.col]
    const targetRow = e.getRow()
    const dataItem: T売上予算 = targetRow.dataItem
    if (e.panel === s.cells) {
      switch (col.binding) {
        case "金額１月str":
        case "金額２月str":
        case "金額３月str":
        case "金額４月str":
        case "金額５月str":
        case "金額６月str":
        case "金額７月str":
        case "金額８月str":
        case "金額９月str":
        case "金額１０月str":
        case "金額１１月str":
        case "金額１２月str":
          if (dataItem.項目 !== e項目.予算) {
            e.cancel = true
          }
          let inputData: string = s.getCellData(e.row, e.col, false)
          inputData = inputData.replaceAll(",", "")
          s.setCellData(e.row, e.col, inputData)
          break
      }
    }
  }

  /**
   * セル編集終了時イベント
   * @param s
   * @param e
   * @returns
   */
  const cellEditEnding = async (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellEditEndingEventArgs
  ) => {
    let col = s.columns[e.col]
    if (e.panel === s.cells) {
      switch (col.binding) {
        case "金額１月str":
        case "金額２月str":
        case "金額３月str":
        case "金額４月str":
        case "金額５月str":
        case "金額６月str":
        case "金額７月str":
        case "金額８月str":
        case "金額９月str":
        case "金額１０月str":
        case "金額１１月str":
        case "金額１２月str":
          let inputData = parseInt(s.activeEditor?.value ?? 0)
          if (inputData == null || isNaN(inputData)) {
            e.cancel = true
          }
          break
      }
    }
  }

  /**
   * セル編集終了後イベント
   * @param s
   * @param e
   * @returns
   */
  const cellEditEnded = async (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellRangeEventArgs
  ) => {
    const col = s.columns[e.col]
    const colBinding = col.binding as keyof T売上予算
    if (e.panel === s.cells) {
      switch (colBinding) {
        case "金額１月str":
        case "金額２月str":
        case "金額３月str":
        case "金額４月str":
        case "金額５月str":
        case "金額６月str":
        case "金額７月str":
        case "金額８月str":
        case "金額９月str":
        case "金額１０月str":
        case "金額１１月str":
        case "金額１２月str":
          if (s.getCellData(e.row, e.col, false)) {
            const newValue: string = s.getCellData(e.row, e.col, false)
            const dataItem = s.rows[e.row].dataItem as T売上予算
            const inputData = parseInt(newValue)
            s.setCellData(e.row, e.col, inputData)
            // 予算入力をされた際に同一部所の年間項目、上期項目、下期項目を更新する
            // 予算以外触れない前提
            const intPropertyName = colBinding.replace(
              "str",
              ""
            ) as 月額プロパティ名
            dataItem[intPropertyName] = inputData
            const 部所情報: T売上予算[] =
              s.collectionView.sourceCollection.filter(
                (d: T売上予算) => d.部所コード === dataItem.部所コード
              )
            const 部所前年実績: T売上予算 | undefined = 部所情報.find(
              (d: T売上予算) => d.項目 === e項目.前年実績
            )
            const 部所前年実績比: T売上予算 | undefined = 部所情報.find(
              (d: T売上予算) => d.項目 === e項目.前年実績比
            )
            //ありえないが存在しなかった場合抜ける
            if (!部所前年実績 || !部所前年実績比) return
            const 部所予算集計データ = 列集計データ生成(dataItem)
            // 予算
            dataItem.年間金額str = cnvUriageStr(
              部所予算集計データ.年間金額,
              "予算"
            )
            dataItem.年間金額 = 部所予算集計データ.年間金額
            dataItem.上期金額str = cnvUriageStr(
              部所予算集計データ.上期金額,
              "予算"
            )
            dataItem.上期金額 = 部所予算集計データ.上期金額
            dataItem.下期金額str = cnvUriageStr(
              部所予算集計データ.下期金額,
              "予算"
            )
            dataItem.下期金額 = 部所予算集計データ.下期金額
            // 前年実績比
            // 修正対象月
            部所前年実績比[intPropertyName] = quotOrZero(
              dataItem[intPropertyName],
              部所前年実績[intPropertyName]
            )
            部所前年実績比[colBinding] = cnvUriageStr(
              部所前年実績比[intPropertyName],
              e項目.前年実績比
            )
            // 合算値
            部所前年実績比.年間金額 = quotOrZero(
              dataItem.年間金額 ?? 0,
              部所前年実績.年間金額 ?? 0
            )
            部所前年実績比.年間金額str = cnvUriageStr(
              部所前年実績比.年間金額,
              e項目.前年実績比
            )
            部所前年実績比.上期金額 = quotOrZero(
              dataItem.上期金額 ?? 0,
              部所前年実績.上期金額 ?? 0
            )
            部所前年実績比.上期金額str = cnvUriageStr(
              部所前年実績比.上期金額,
              e項目.前年実績比
            )
            部所前年実績比.下期金額 = quotOrZero(
              dataItem.下期金額 ?? 0,
              部所前年実績.下期金額 ?? 0
            )
            部所前年実績比.下期金額str = cnvUriageStr(
              部所前年実績比.下期金額,
              e項目.前年実績比
            )

            s.refresh()
          }
          break
      }
    }
  }
  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    const cellBinding = e.getColumn().binding
    const targetRow = e.getRow()
    const dataItem: T売上予算 = targetRow.dataItem
    if (e.panel === f.cells) {
      switch (cellBinding) {
        case "金額１月str":
        case "金額２月str":
        case "金額３月str":
        case "金額４月str":
        case "金額５月str":
        case "金額６月str":
        case "金額７月str":
        case "金額８月str":
        case "金額９月str":
        case "金額１０月str":
        case "金額１１月str":
        case "金額１２月str":
          if (dataItem.項目 !== "予算") {
            wjCore.toggleClass(e.cell, "read-only-cell", true)
          }
          break
      }
    }
  }

  /**
   * 明細グリッドセル結合マネージャー
   */
  class RestrictedMergeManager extends wjGrid.MergeManager {
    getMergedRange(p: wjGrid.GridPanel, r: number, c: number, clip = true) {
      var rng = null
      rng = new wjGrid.CellRange(r, c)
      const マージ判定用bindList: { binding: string; isRequired: boolean }[] = [
        {
          binding: "部所名",
          isRequired: true,
        },
      ]
      const マージ対象bindList: string[] = [
        "部所名",
        "報告テキスト１",
        "報告テキスト２",
        "報告テキスト３",
        "報告テキスト４",
        "報告テキスト５",
      ]
      const isMergeCell = (rowNumber: number) => {
        return !マージ判定用bindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      // bindListの列が全て同じ値であれば結合する
      if (マージ対象bindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && isMergeCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (rng.row2 < p.rows.length - 1 && isMergeCell(rng.row2 + 2)) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          rng = null
        }
      }
      return rng
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    setIsConfirmModalShow(true)
  }
  /**
   * エラークリア
   */
  const clearError = () => {
    dispatch(clearAlert())
  }
  /**
   * 登録・更新
   */
  const submit = async () => {
    try {
      const res = await new uriageYosanService().putUriageYosanList(setData())
      if (res) {
        showInfoToast(`売上予算の更新が完了しました。`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const setData = () => {
    const gridItems: T売上予算[] = flexGrid?.collectionView.sourceCollection
    const putList: UriageYosanListPutReq[] = []
    gridItems
      .filter((d) => d.項目 === "予算")
      .forEach((d) => {
        d.売上予算List?.forEach((yosanData) => {
          if (yosanData.年月) {
            let 予算額 = 0
            let 月 = yosanData.年月.slice(-2)
            // 行の予算額を振り分ける
            switch (月) {
              case "01":
                予算額 = parseInt(
                  d.金額１月str ? d.金額１月str.replaceAll(",", "") : "0"
                )
                break
              case "02":
                予算額 = parseInt(
                  d.金額２月str ? d.金額２月str.replaceAll(",", "") : "0"
                )
                break
              case "03":
                予算額 = parseInt(
                  d.金額３月str ? d.金額３月str.replaceAll(",", "") : "0"
                )
                break
              case "04":
                予算額 = parseInt(
                  d.金額４月str ? d.金額４月str.replaceAll(",", "") : "0"
                )
                break
              case "05":
                予算額 = parseInt(
                  d.金額５月str ? d.金額５月str.replaceAll(",", "") : "0"
                )
                break
              case "06":
                予算額 = parseInt(
                  d.金額６月str ? d.金額６月str.replaceAll(",", "") : "0"
                )
                break
              case "07":
                予算額 = parseInt(
                  d.金額７月str ? d.金額７月str.replaceAll(",", "") : "0"
                )
                break
              case "08":
                予算額 = parseInt(
                  d.金額８月str ? d.金額８月str.replaceAll(",", "") : "0"
                )
                break
              case "09":
                予算額 = parseInt(
                  d.金額９月str ? d.金額９月str.replaceAll(",", "") : "0"
                )
                break
              case "10":
                予算額 = parseInt(
                  d.金額１０月str ? d.金額１０月str.replaceAll(",", "") : "0"
                )
                break
              case "11":
                予算額 = parseInt(
                  d.金額１１月str ? d.金額１１月str.replaceAll(",", "") : "0"
                )
                break
              case "12":
                予算額 = parseInt(
                  d.金額１２月str ? d.金額１２月str.replaceAll(",", "") : "0"
                )
                break
            }
            const putData: UriageYosanListPutReq = {
              部所コード: yosanData.部所コード,
              売上予算ID: yosanData.売上予算ID,
              予算額: 予算額,
              更新日時: yosanData.更新日時,
            }
            putList.push(putData)
          }
        })
      })
    return putList
  }

  /**
   * gridの行フォーマット作成用
   * @param i 数値
   * @param 項目 予算／実績／前年実績比
   * @return string
   */
  const cnvUriageStr = (i: number, 項目: string) => {
    if (項目 === e項目.前年実績比) {
      return new Intl.NumberFormat("ja", {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(i)
    } else {
      return new Intl.NumberFormat().format(i)
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年度, set年度] = useState<number | null>()

  // 年度
  const [年度ComboBox, set年度ComboBox] = useState<TWijmoComboBox<
    number | undefined,
    T年ComboBoxItem
  > | null>(null)
  const [年度isLoadEnded, set年度isLoadEnded] = useState<boolean>(false)

  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  // 運行場所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
    set年度(dayjs(当営業日).year())
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `売上予算（部所年間）`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">売上予算（部所年間）</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-20rem">
              <Card.Body>
                <div>
                  <Link
                    to={
                      util.getMenuPath(予算_実績メニューコード.売上予算_全社)[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button className="mx-1" disabled={isSearching}>
                      全社
                    </Button>
                  </Link>
                  <Button className="mx-1" disabled={true}>
                    部所（年）
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-30rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-8rem">
                                <YearComboBox
                                  placeholder="年度"
                                  is年度={true}
                                  isLoadEnded={年度isLoadEnded}
                                  isRequired={false}
                                  setIsLoadEnded={set年度isLoadEnded}
                                  selectedValue={年度}
                                  setSelectedValue={(v) => {
                                    set年度(v)
                                  }}
                                  ComboBox={年度ComboBox}
                                  setComboBox={set年度ComboBox}></YearComboBox>
                              </div>
                              <ComboBox.Busyo
                                placeholder="部所"
                                isLoadEnded={部所isLoadEnded}
                                setIsLoadEnded={set部所isLoadEnded}
                                isAllSelect={true}
                                isRequired={false}
                                itemsSource={部所ItemSource}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                selectedValue={部所コード}
                                setSelectedValue={(v) => {
                                  set部所コード(v)
                                }}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                            <Button
                              type="submit"
                              variant="primary"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={`${gridId}`}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={0}
                  isEnablePageSize={"hidden"}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  gridProperties={{
                    mergeManager: new RestrictedMergeManager(),
                    isReadOnly: false,
                    allowSorting: false,
                    frozenColumns: 2,
                  }}>
                  <wjrGrid.FlexGridColumn
                    binding="部所名"
                    isReadOnly={true}
                    allowDragging={false}
                    cssClass="dummy-header-cell"
                    width={192}
                    header="部所名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="項目"
                    isReadOnly={true}
                    cssClass="dummy-header-cell"
                    allowDragging={false}
                    width={96}
                    header="項目">
                    <wjrGrid.FlexGridCellTemplate
                      cellType={wjrGrid.CellTemplateType.Cell}
                      template={(
                        context: TWijmoCellTemplateContext<T売上予算>
                      ) => <>{context.item.項目}</>}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="年間金額str"
                    isReadOnly={true}
                    cssClass={"number-col read-only-cell"}
                    width={120}
                    header="年間"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額４月str"
                    width={120}
                    cssClass="number-col"
                    header="４月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額５月str"
                    width={120}
                    cssClass="number-col"
                    header="５月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額６月str"
                    width={120}
                    cssClass="number-col"
                    header="６月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額７月str"
                    width={120}
                    cssClass="number-col"
                    header="７月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額８月str"
                    width={120}
                    cssClass="number-col"
                    header="８月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額９月str"
                    width={120}
                    cssClass="number-col"
                    header="９月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="上期金額str"
                    isReadOnly={true}
                    cssClass={"number-col read-only-cell"}
                    width={120}
                    header="上期"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額１０月str"
                    width={120}
                    cssClass="number-col"
                    header="１０月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額１１月str"
                    width={120}
                    cssClass="number-col"
                    header="１１月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額１２月str"
                    width={120}
                    cssClass="number-col"
                    header="１２月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額１月str"
                    width={120}
                    cssClass="number-col"
                    header="１月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額２月str"
                    width={120}
                    cssClass="number-col"
                    header="２月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額３月str"
                    width={120}
                    cssClass="number-col"
                    header="３月"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="下期金額str"
                    isReadOnly={true}
                    cssClass={"number-col read-only-cell"}
                    width={120}
                    header="下期"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
                <>
                  <Button
                    className="mx-1"
                    variant="waiting"
                    disabled={isSearching}
                    onClick={() => {
                      beforeSubmit()
                    }}>
                    更新
                  </Button>
                </>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </>
  )
}

export default UriageYosanNenkanRegister
